import React, { useEffect, useRef, useState } from 'react';
import './session.scss';

import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { responseLogWithNotification } from '../../../utils/utils';
import { loadSessionList } from '../actions';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Breadcrumbs from '../../../components/layout/Breadcrumbs';
import TabMenu from '../../../components/base/TabMenu/TabMenu';
import BlockHeader from '../../../components/layout/BlockHeader';
import VerticalGrid from '../../../components/base/Grid/VerticalGrid';

export default function ViolationPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const [selectedPhoto, selectPhoto] = useState(0);
  const [currentTimeOut, setCurrentTimeOut] = useState(null);
  const { updatePeriod } = useSelector(getSystemData);
  const [selectedPFPhotoType, selectPFPhotoType] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const photoList = [{ photo: 'photo-1.jpeg' }, { photo: 'photo-2.jpeg' }, { photo: 'photo-3.jpeg' }, { photo: 'photo-4.jpeg' }, { photo: 'photo-1.jpeg' }];
  const maxCount = 4;
  const viewedList = photoList.slice(startIndex, maxCount + startIndex);
  const intl = useIntl();
  const { formatMessage } = intl;
  const pfPhotoType = [
    { value: 0, label: formatMessage({ id: 'pf.photo.type.0' }) },
    { value: 1, label: formatMessage({ id: 'pf.photo.type.1' }) },
    { value: 2, label: formatMessage({ id: 'pf.photo.type.2' }) },
  ];
  const loadData = () => {
    const p1 = dispatch(loadSessionList()).catch(responseLogWithNotification);
    if (currentTimeOut) {
      clearTimeout(currentTimeOut);
    }
    Promise.all([p1]).then(values => {
      if (updatePeriod) {
        const t = setTimeout(loadData, updatePeriod * 1000);
        setCurrentTimeOut(t);
      }
    });
  };
  useEffect(loadData, [updatePeriod]);
  const tabOptions = [
    ...pfPhotoType,
    { value: 3, label: formatMessage({ id: 'pf.photo.type.3' }) },
  ];

  const rows = {
    type: formatMessage({ id: 'violation.type' }),
    start: formatMessage({ id: 'violation.start' }),
    end: formatMessage({ id: 'violation.end' }),
    code: formatMessage({ id: 'violation.code' }),
    date: formatMessage({ id: 'date' }),
    address: formatMessage({ id: 'address' }),
    reg_number: formatMessage({ id: 'session.reg_number' }),
    gps: formatMessage({ id: 'session.gps' }),
    chanel: formatMessage({ id: 'session.chanel' }),
    reg_number_type: formatMessage({ id: 'session.reg_number_type' }),
  };

  const data = {
    type: 'Выезд за стоп-линию на запрещающий сигнал светофора',
    start: '2024-07-06T11:10:05.000Z',
    end: '2024-07-06T11:22:54.000Z',
    date: '2024-07-06T11:22:54.000Z',
    code: 344,
    zone: 'A',
    preset: 'A',
    chanel: 1,
    reg_number: 'С582МР152',
    reg_number_type: 'RU 1',
    gps: '56.021196, 37.479523',
    address: 'г. Москва, ул. Тверская, д. 59, корп. 1',
  };
  const prevButton = photoList.length > maxCount && startIndex + maxCount < photoList.length;
  const nextButton = photoList.length > maxCount && startIndex + maxCount < photoList.length;

  return (
    <div className="page violation-page">
      <Loader loading={false} />
      <Breadcrumbs links={[{ name: formatMessage({ id: 'menu.session' }), href: '/session' }, { name: formatMessage({ id: 'violation' }), href: '/session/violation' }]} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'violation' })}</div>
        <FilterRow>
          <Button>
            <Icons customIcon icon="download" className="" />
            {formatMessage({ id: 'download' })}
          </Button>
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="violation-content-wrapper frame custom-scroll-theme">
            <div className="violation-photo-wrapper">
              <div
                className="violation-photo"
                style={{ background: `url(${process.env.PUBLIC_URL}/mock/${viewedList[selectedPhoto].photo}) no-repeat` }}
              >
                <TabMenu
                  options={tabOptions}
                  selectedTab={selectedPFPhotoType}
                  onSelectOptions={item => selectPFPhotoType(item.value)}
                />
              </div>
              <div className="pf-list-row">
                <div className="pf-list-wrapper">
                  <div className={classNames('pf-arrow pf-up white-button-style', { disabled: prevButton })} onClick={() => (prevButton ? null : setStartIndex(startIndex - 1))}><Icons customIcon icon="arrow-down" /></div>
                  {viewedList.map((item, key) => (
                    <div
                      key={key}
                      className={classNames('pf-list-item', { selected: selectedPhoto === key })}
                      onClick={() => selectPhoto(key)}
                      style={{ background: `url(${process.env.PUBLIC_URL}/mock/${item.photo}) no-repeat` }}
                    />
                  ))}
                  <div className={classNames('pf-arrow pf-down white-button-style', { disabled: !nextButton })} onClick={() => (!nextButton ? null : setStartIndex(startIndex + 1))}><Icons customIcon icon="arrow-down" /></div>
                </div>
              </div>
            </div>
            <div className="violation-info">
              <div className="violation-info-data">
                <BlockHeader text={`${formatMessage({ id: 'violation' })} 1`} />
                <VerticalGrid data={data} rows={rows} />
              </div>
              <div className="null-block" />
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
